module.exports = __webpack_public_path__ + "static/media/idle.97a06501.svg";


//////////////////
// WEBPACK FOOTER
// ./src/medias/idle.svg
// module id = 589
// module chunks = 0